// Action
import ActionArm from './action/Arm';
import ActionBrake from './action/Brake';
import ActionDisarm from './action/Disarm';
import ActionElevate from './action/Elevate';
import ActionGoto from './action/Goto';
import ActionGripper from './action/Gripper';
import ActionInspection from './action/Inspection';
import ActionLand from './action/Land';
import ActionManualControl from './action/ManualControl';
import ActionQLand from './action/QLand';
import ActionReturn from './action/Return';
import ActionSetServo from './action/SetServo';
import ActionStickControl from './action/StickControl';
import ActionTakeoff from './action/Takeoff';
// Camera
import CameraGimbal from './camera/Gimbal';
import CameraLiveView from './camera/LiveView';
import CameraSetAutoShoot from './camera/SetAutoShoot';
import CameraShoot from './camera/Shoot';
// Mission
import MissionClear from './mission/Clear';
import MissionLoad from './mission/Load';
import MissionResume from './mission/Resume';
import MissionStart from './mission/Start';
import MissionUpload from './mission/Upload';
// Mode
import ModeAltHold from './mode/AltHold';
import ModeAuto from './mode/Auto';
import ModeBrake from './mode/Brake';
import ModeGuided from './mode/Guided';
import ModeHold from './mode/Hold';
import ModeLoiter from './mode/Loiter';
import ModePosHold from './mode/PosHold';
import ModeQRTL from './mode/QRTL';
import ModeRTL from './mode/RTL';
import ModeStabilize from './mode/Stabilize';

export {
  // Action
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionGripper,
  ActionInspection,
  ActionLand,
  ActionManualControl,
  ActionQLand,
  ActionReturn,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  // Camera
  CameraGimbal,
  CameraLiveView,
  CameraSetAutoShoot,
  CameraShoot,
  // Mission
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  // Mode
  ModeAltHold,
  ModeAuto,
  ModeBrake,
  ModeGuided,
  ModeHold,
  ModeLoiter,
  ModePosHold,
  ModeQRTL,
  ModeRTL,
  ModeStabilize,
};

const commands = [
  // Action
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionGripper,
  ActionInspection,
  ActionLand,
  ActionManualControl,
  ActionQLand,
  ActionReturn,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  // Camera
  CameraGimbal,
  CameraLiveView,
  CameraSetAutoShoot,
  CameraShoot,
  // Mission
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  // Mode
  ModeAltHold,
  ModeAuto,
  ModeBrake,
  ModeGuided,
  ModeHold,
  ModeLoiter,
  ModePosHold,
  ModeQRTL,
  ModeRTL,
  ModeStabilize,
];

export default commands;
